import { ActionIcon, Box, CSSObject } from "@mantine/core";
import cn from "classnames";
import { SetStateAction } from "jotai";
import { pxToRem } from "theme";

import Flex from "components/Flex";
import { DeleteIcon } from "components/Icons/Delete";
import { UnUploadedImage } from "components/PhotoUpload/types";
import Text from "components/Text";

import { useClientTranslation } from "../../hooks/useClientTranslation";
import { useStyles } from "./styles";
import { GridImage } from "./types";

export type PhotoGridProps = {
  images: GridImage[];
  deleteFromAtom?: (update: SetStateAction<UnUploadedImage[]>) => Promise<void>;
  gridGap?: string | number;
  imageFit?: CSSObject["objectFit"];
  showCaptions?: boolean;
  className?: string;
};

export const PhotoGrid = ({
  images,
  deleteFromAtom,
  gridGap = pxToRem[12],
  imageFit,
  showCaptions,
  className,
}: PhotoGridProps) => {
  const { classes } = useStyles({ gridGap, imageFit });
  const { t } = useClientTranslation();

  return (
    <Box className={cn(classes.photoGrid, className && className)}>
      {images.map(({ id, src, alt, component: Image, caption }: GridImage) => (
        <Flex key={id} className={classes.photoGridCell}>
          <Flex className={classes.imageContainer}>
            {deleteFromAtom && id && (
              <ActionIcon
                aria-label="Delete image"
                onClick={() => deleteFromAtom((photos) => photos?.filter((photo) => id !== photo.id))}
                className={classes.deleteImageIcon}
              >
                <DeleteIcon />
              </ActionIcon>
            )}
            {Image ? (
              <Image alt={alt} className={`${classes.image}`} />
            ) : (
              <img src={src} alt={alt} className={`${classes.image}`} />
            )}
          </Flex>
          {showCaptions && caption && (
            <Text sizeVariant="md" className={classes.caption}>
              {t(caption)}
            </Text>
          )}
        </Flex>
      ))}
    </Box>
  );
};
